import React from 'react';
import { Icon, IconType } from '@routific/hive';

interface CalendarIconProps {
  focused?: boolean;
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ focused }) => {
  return (
    <Icon icon={IconType.Calendar} type={focused ? 'accent' : 'secondary'} />
  );
};

export default CalendarIcon;
